// components/conference/ConferenceHero.tsx
'use client';

import styles from './ConferenceHero.module.scss';
import {
  CalendarDays,
  Clock,
  MapPin,
  ChevronRight,
  CalendarCheck,
  BadgeCheck,
  Users,
} from 'lucide-react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

export default function ConferenceHero() {
  const router = useRouter();

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();

    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      window.history.pushState(null, '', `#${targetId}`);
    } else {
      router.push(`#${targetId}`);
    }
  };

  return (
    <section className={styles.hero}>
      {/* СЕО-заголовок */}
      <h1 className={styles.seoHeading}>
        Ежегодная очная конференция КВИЗ по госзакупкам 2026 в Перми | Регистрация
      </h1>

      {/* Градиентные орбы */}
      <div className={styles.gradientOrbs}>
        <div className={styles.orb1}></div>
        <div className={styles.orb2}></div>
      </div>

      <div className={styles.container}>
        <div className={styles.content}>
          {/* Хлебные крошки */}
          <div className={styles.breadcrumbs}>
            <Link href="/events" className={styles.breadcrumbLink}>
              Все мероприятия
            </Link>
            <span className={styles.breadcrumbSeparator}>/</span>
            <span className={styles.breadcrumbCurrent}>Конференция КВИЗ</span>
          </div>

          {/* Бейдж с датой */}
          <div className={styles.badge}>
            <CalendarCheck size={20} />
            <span>25 марта 2026 года</span>
          </div>

          {/* Заголовок: ежегодная очная конференция + КВИЗ */}
          <h2 className={styles.title}>
            <span className={styles.titleLine}>Ежегодная очная</span>
            <span className={styles.titleLine}>
              конференция <span className={styles.highlight}>КВИЗ</span>
            </span>
          </h2>

          {/* Подзаголовок: участники + описание */}
          <p className={styles.subtitle}>
            Впервые участники – Заказчики и Поставщики
          </p>
          <p className={styles.subtitle} style={{ marginTop: '-20px' }}>
            Выступление экспертов, разбор практических кейсов, решение актуальных задач, общение с коллегами, поставщиками и экспертами
          </p>

          {/* Детали конференции */}
          <div className={styles.stats}>
            <div className={styles.stat}>
              <div className={styles.statIcon}>
                <CalendarDays size={28} />
              </div>
              <div className={styles.statContent}>
                <div className={styles.statNumber}>25 марта</div>
                <div className={styles.statLabel}>дата проведения</div>
              </div>
            </div>

            <div className={styles.stat}>
              <div className={styles.statIcon}>
                <Clock size={28} />
              </div>
              <div className={styles.statContent}>
                <div className={styles.statNumber}>11:00–13:00</div>
                <div className={styles.statLabel}>время проведения</div>
              </div>
            </div>

            <div className={styles.stat}>
              <div className={styles.statIcon}>
                <Users size={28} />
              </div>
              <div className={styles.statContent}>
                <div className={styles.statNumber}>Вход свободный</div>
                <div className={styles.statLabel}>по предварительной регистрации</div>
              </div>
            </div>
          </div>

          {/* CTA секция */}
          <div className={styles.ctaSection}>
            <div className={styles.buttonGroup}>
              <a
                href="#form"
                className={styles.primaryButton}
                onClick={(e) => handleScroll(e, 'form')}
                aria-label="Забронировать место на конференции"
              >
                <span>Забронировать место</span>
                <ChevronRight size={32} />
              </a>
            </div>

            {/* Информация о месте проведения */}
            <p className={styles.ctaNote}>
              <MapPin size={20} />
              <span>
                <strong>Место проведения:</strong> г. Пермь, ул. Монастырская, 2, банкетный зал White Hall
              </span>
            </p>

            {/* Информация о регистрации команды */}
            <p className={styles.ctaNote} style={{ marginTop: '8px' }}>
              <BadgeCheck size={20} />
              <span>Можно зарегистрироваться одному или всей командой</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}